"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import React from "react";
import { Card, Button, Tab, Loading, Grid, Message } from "@alifd/next";
import Ansi from "ansi-to-react";
import classNames from "classnames";
import { connect } from "dva";
import "./index.less";
import { Link, routerRedux } from "dva/router";
import {
  resumeApplicationWorkflowRecord,
  rollbackApplicationWorkflowRecord,
  terminateApplicationWorkflowRecord
} from "../../../../api/application";
import {
  detailWorkflowRecord,
  getWorkflowRecordInputs,
  getWorkflowRecordLogs,
  getWorkflowRecordOutputs
} from "../../../../api/workflows";
import Empty from "../../../../components/Empty";
import { If } from "../../../../components/If";
import PipelineGraph from "../../../../components/PipelineGraph";
import { Translation } from "../../../../components/Translation";
import i18n from "../../../../i18n";
import { convertAny, momentDate, timeDiff } from "../../../../utils/common";
import RunStatusIcon from "../../../PipelineRunPage/components/RunStatusIcon";
import { HiOutlineRefresh } from "react-icons/hi";
const { Row, Col } = Grid;
let ApplicationWorkflowRecord = class extends React.Component {
  constructor(props) {
    super(props);
    this.loadWorkflowRecord = () => {
      const { recordName, workflow, applicationDetail } = this.props;
      this.setState({ statusLoading: true });
      detailWorkflowRecord({
        appName: applicationDetail.name,
        workflowName: workflow.name,
        record: recordName
      }).then((res) => {
        if (res) {
          this.setState({ showRecord: res });
          if (res.status && ["terminated", "failed", "succeeded"].indexOf(res.status) == -1 && !this.loop && !this.disableLoop) {
            this.loop = true;
            window.setTimeout(() => {
              this.loop = false;
              this.loadWorkflowRecord();
            }, 3e3);
          }
        }
      }).finally(() => {
        this.setState({ statusLoading: false });
      });
    };
    this.onStepClick = (step) => {
      this.setState({ showDetail: true, stepStatus: step }, () => {
        const { activeKey } = this.state;
        this.onTabChange(activeKey);
      });
    };
    this.onTabChange = (key) => {
      const { stepStatus } = this.state;
      this.setState({ activeKey: key });
      if (key == "outputs" && stepStatus) {
        this.onGetStepOutput();
      }
      if (key == "detail" && stepStatus) {
        this.onGetStepLog();
      }
      if (key == "inputs" && stepStatus) {
        this.onGetStepInput();
      }
    };
    this.onGetStepOutput = () => {
      const { applicationDetail, workflow, recordName } = this.props;
      const { stepStatus } = this.state;
      if (stepStatus) {
        this.setState({ outputLoading: true });
        getWorkflowRecordOutputs({
          appName: applicationDetail.name,
          workflowName: workflow.name,
          record: recordName,
          step: stepStatus?.name
        }).then((res) => {
          const outputs = res && Array.isArray(res.outputs) && res.outputs.length > 0 ? res.outputs[0] : void 0;
          this.setState({
            outputs
          });
        }).finally(() => {
          this.setState({ outputLoading: false });
        });
      }
    };
    this.onGetStepLog = () => {
      const { applicationDetail, workflow, recordName } = this.props;
      const { stepStatus } = this.state;
      if (stepStatus) {
        this.setState({ inputLoading: true });
        getWorkflowRecordLogs({
          appName: applicationDetail.name,
          workflowName: workflow.name,
          record: recordName,
          step: stepStatus?.name
        }).then((res) => {
          this.setState({ logs: res && res.log ? res.log.split("\n") : [], logSource: res.source });
        }).finally(() => {
          this.setState({ logLoading: false });
        });
      }
    };
    this.onGetStepInput = () => {
      const { applicationDetail, workflow, recordName } = this.props;
      const { stepStatus } = this.state;
      if (stepStatus) {
        this.setState({ inputLoading: true });
        getWorkflowRecordInputs({
          appName: applicationDetail.name,
          workflowName: workflow.name,
          record: recordName,
          step: stepStatus?.name
        }).then((res) => {
          const input = res && Array.isArray(res.inputs) && res.inputs.length > 0 ? res.inputs[0] : void 0;
          this.setState({
            inputs: input
          });
        }).finally(() => {
          this.setState({ inputLoading: false });
        });
      }
    };
    this.onResumeApplicationWorkflowRecord = () => {
      const { applicationDetail, workflow, recordName } = this.props;
      const params = {
        appName: applicationDetail.name,
        workflowName: workflow.name,
        recordName
      };
      this.setState({ resumeLoading: true });
      resumeApplicationWorkflowRecord(params).then((re) => {
        if (re) {
          Message.success("Workflow resumed successfully");
          this.loadWorkflowRecord();
        }
      }).finally(() => {
        this.setState({ resumeLoading: false });
      });
    };
    this.onRollbackApplicationWorkflowRecord = () => {
      const { applicationDetail, workflow, recordName, dispatch, envName } = this.props;
      const params = {
        appName: applicationDetail.name,
        workflowName: workflow.name,
        recordName
      };
      this.setState({ rollbackLoading: true });
      rollbackApplicationWorkflowRecord(params).then((re) => {
        if (re) {
          Message.success(i18n.t("Workflow rollback successfully"));
          if (dispatch && re.name) {
            dispatch(
              routerRedux.push(
                `/applications/${applicationDetail.name}/envbinding/${envName}/workflow/records/${re.name}`
              )
            );
          }
        }
      }).finally(() => {
        this.setState({ rollbackLoading: false });
      });
    };
    this.onTerminateApplicationWorkflowRecord = () => {
      const { applicationDetail, workflow, recordName } = this.props;
      const params = {
        appName: applicationDetail.name,
        workflowName: workflow.name,
        recordName
      };
      this.setState({ terminateLoading: true });
      terminateApplicationWorkflowRecord(params).then((re) => {
        if (re) {
          Message.success(i18n.t("Workflow terminated successfully"));
          this.loadWorkflowRecord();
        }
      }).finally(() => {
        this.setState({ terminateLoading: false });
      });
    };
    this.state = {
      zoom: 1,
      showDetail: false,
      statusLoading: true,
      activeKey: "detail"
    };
    this.loop = false;
    this.disableLoop = false;
  }
  componentDidMount() {
    this.loadWorkflowRecord();
  }
  componentWillUnmount() {
    this.disableLoop = true;
  }
  componentDidUpdate(prevProps) {
    if (prevProps.recordName !== this.props.recordName) {
      this.loadWorkflowRecord();
    }
  }
  render() {
    const { workflow, applicationDetail } = this.props;
    const {
      statusLoading,
      zoom,
      showRecord,
      showDetail,
      stepStatus,
      logLoading,
      logSource,
      logs,
      inputs,
      inputLoading,
      outputs,
      outputLoading,
      rollbackLoading,
      resumeLoading,
      terminateLoading
    } = this.state;
    let stepSpec;
    workflow?.steps?.map((step) => {
      if (stepStatus && step.name == stepStatus.name) {
        stepSpec = step;
      }
      step.subSteps?.map((sub) => {
        if (stepStatus && sub.name == stepStatus.name) {
          stepSpec = sub;
        }
      });
    });
    let properties = stepSpec && stepSpec.properties;
    if (typeof properties === "string") {
      const newProperties = JSON.parse(properties);
      properties = newProperties;
    }
    return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(Row, { className: "description", wrap: true }, /* @__PURE__ */ React.createElement(Col, { xl: 16, xs: 24 }, /* @__PURE__ */ React.createElement("div", { className: "name_metadata" }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: "name" }, showRecord?.name), /* @__PURE__ */ React.createElement("div", { className: "metadata" }, /* @__PURE__ */ React.createElement("div", { className: "start_at" }, /* @__PURE__ */ React.createElement("span", { className: "label_key" }, "Started at:"), /* @__PURE__ */ React.createElement("time", { className: "label_value" }, momentDate(showRecord?.startTime))), /* @__PURE__ */ React.createElement("div", { className: "duration_time" }, /* @__PURE__ */ React.createElement("span", { className: "label_key" }, "Duration:"), /* @__PURE__ */ React.createElement("time", { className: "label_value" }, timeDiff(showRecord?.startTime, showRecord?.endTime))), /* @__PURE__ */ React.createElement("div", { className: "mode" }, /* @__PURE__ */ React.createElement("span", { className: "label_key" }, "Mode:"), /* @__PURE__ */ React.createElement("time", { className: "label_value" }, showRecord?.mode || "StepByStep-DAG")), /* @__PURE__ */ React.createElement("div", { className: "mode" }, /* @__PURE__ */ React.createElement("span", { className: "label_key" }, "Revision:"), /* @__PURE__ */ React.createElement("time", { className: "label_value" }, /* @__PURE__ */ React.createElement(Link, { to: `/applications/${applicationDetail.name}/revisions` }, showRecord?.applicationRevision))))), /* @__PURE__ */ React.createElement("div", { className: "flexright" }, /* @__PURE__ */ React.createElement(
      Button,
      {
        type: "secondary",
        loading: statusLoading,
        onClick: () => {
          this.loadWorkflowRecord();
        }
      },
      /* @__PURE__ */ React.createElement(HiOutlineRefresh, null)
    )))), /* @__PURE__ */ React.createElement(Col, { xl: 8, xs: 24 }, /* @__PURE__ */ React.createElement(
      "div",
      {
        className: classNames(
          "status",
          { warning: showRecord?.status == "failed" || showRecord?.status === "terminated" },
          { success: showRecord?.status == "succeeded" }
        )
      },
      /* @__PURE__ */ React.createElement(RunStatusIcon, { status: showRecord?.status }),
      /* @__PURE__ */ React.createElement(If, { condition: showRecord?.message }, /* @__PURE__ */ React.createElement("div", { className: "message" }, /* @__PURE__ */ React.createElement("div", { className: "summary" }, showRecord?.status == "failed" ? "Error Summary" : "Summary"), /* @__PURE__ */ React.createElement("p", { className: "text" }, showRecord?.message))),
      /* @__PURE__ */ React.createElement(If, { condition: showRecord?.status === "suspending" }, /* @__PURE__ */ React.createElement("div", { className: classNames("suspend-actions") }, /* @__PURE__ */ React.createElement("div", { className: "desc" }, /* @__PURE__ */ React.createElement(Translation, null, "This workflow needs your approving")), /* @__PURE__ */ React.createElement(Button.Group, null, /* @__PURE__ */ React.createElement(
        Button,
        {
          type: "secondary",
          size: "small",
          loading: rollbackLoading,
          className: "margin-top-5 margin-left-8",
          onClick: this.onRollbackApplicationWorkflowRecord,
          title: "Rollback to last ready revision"
        },
        /* @__PURE__ */ React.createElement(Translation, null, "Rollback")
      ), /* @__PURE__ */ React.createElement(
        Button,
        {
          type: "secondary",
          size: "small",
          loading: terminateLoading,
          className: "margin-top-5 margin-left-8",
          title: "Terminate this workflow",
          onClick: this.onTerminateApplicationWorkflowRecord
        },
        /* @__PURE__ */ React.createElement(Translation, null, "Terminate")
      ), /* @__PURE__ */ React.createElement(
        Button,
        {
          type: "primary",
          size: "small",
          loading: resumeLoading,
          className: "margin-top-5 margin-left-8",
          title: "Approve and continue this workflow",
          onClick: this.onResumeApplicationWorkflowRecord
        },
        /* @__PURE__ */ React.createElement(Translation, null, "Continue")
      ))))
    ))), /* @__PURE__ */ React.createElement(
      "div",
      {
        className: "run-studio",
        style: {
          paddingLeft: "2rem",
          height: "calc(100vh - 400px)"
        },
        onClick: () => {
          this.setState({ showDetail: false });
        }
      },
      /* @__PURE__ */ React.createElement("div", { className: classNames("studio") }, showRecord && /* @__PURE__ */ React.createElement(
        PipelineGraph,
        {
          name: `${showRecord?.name}`,
          zoom,
          onNodeClick: this.onStepClick,
          steps: showRecord?.steps
        }
      )),
      /* @__PURE__ */ React.createElement(If, { condition: showDetail && stepStatus }, /* @__PURE__ */ React.createElement(
        Card,
        {
          title: stepStatus?.alias || stepStatus?.name || stepStatus?.id,
          className: classNames("detail"),
          contentHeight: "auto",
          onClick: (event) => {
            event.stopPropagation();
          }
        },
        /* @__PURE__ */ React.createElement(Tab, { animation: true, size: "medium", onChange: this.onTabChange }, /* @__PURE__ */ React.createElement(Tab.Item, { title: /* @__PURE__ */ React.createElement(Translation, null, "Detail"), key: "detail" }, /* @__PURE__ */ React.createElement("div", { className: "detail-page" }, /* @__PURE__ */ React.createElement("div", { className: "step-info padding16" }, stepStatus && /* @__PURE__ */ React.createElement("tbody", null, /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("th", null, "Step:"), /* @__PURE__ */ React.createElement("td", null, stepStatus.name || stepStatus?.id)), /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("th", null, "Type:"), /* @__PURE__ */ React.createElement("td", null, stepStatus.type)), /* @__PURE__ */ React.createElement(If, { condition: stepSpec?.if }, /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("th", null, "Condition:"), /* @__PURE__ */ React.createElement("td", null, stepSpec?.if))), /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("th", null, "First Execute Time:"), /* @__PURE__ */ React.createElement("td", null, stepStatus.firstExecuteTime)), /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("th", null, "Last Execute Time:"), /* @__PURE__ */ React.createElement("td", null, stepStatus.lastExecuteTime)), /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("th", null, "Duration:"), /* @__PURE__ */ React.createElement("td", null, timeDiff(stepStatus.firstExecuteTime, stepStatus.lastExecuteTime))), /* @__PURE__ */ React.createElement(If, { condition: stepSpec?.timeout }, /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("th", null, "Timeout:"), /* @__PURE__ */ React.createElement("td", null, stepSpec?.timeout))), /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("th", null, "Phase:"), /* @__PURE__ */ React.createElement("td", { className: "step-status-text-" + stepStatus.phase }, stepStatus.phase)), /* @__PURE__ */ React.createElement(If, { condition: stepStatus.message || stepStatus.reason }, /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("th", null, "Message(Reason):"), /* @__PURE__ */ React.createElement("td", null, `${stepStatus.message || ""}`, stepStatus.reason && `(${stepStatus.reason})`))))), logSource && /* @__PURE__ */ React.createElement("div", { className: "step-log" }, /* @__PURE__ */ React.createElement("div", { className: "header" }, /* @__PURE__ */ React.createElement("div", null, "Step Logs"), /* @__PURE__ */ React.createElement(
          Button,
          {
            loading: logLoading,
            onClick: () => {
              this.onGetStepLog();
            },
            style: { color: "#fff" },
            size: "small"
          },
          /* @__PURE__ */ React.createElement(HiOutlineRefresh, null)
        )), /* @__PURE__ */ React.createElement("div", { className: "log-content" }, logs?.map((line, i) => {
          return /* @__PURE__ */ React.createElement("div", { key: `log-${i}`, className: "logLine" }, /* @__PURE__ */ React.createElement("span", { className: "content" }, /* @__PURE__ */ React.createElement(Ansi, { linkify: true }, line)));
        }))))), /* @__PURE__ */ React.createElement(Tab.Item, { title: i18n.t("Properties").toString(), key: "properties" }, /* @__PURE__ */ React.createElement("div", { className: "step-info padding16" }, /* @__PURE__ */ React.createElement("tbody", null, properties && Object.keys(properties).map((key) => {
          return /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("th", null, key, ":"), /* @__PURE__ */ React.createElement("td", null, properties && convertAny(properties[key])));
        })))), /* @__PURE__ */ React.createElement(Tab.Item, { title: i18n.t("Outputs"), key: "outputs" }, /* @__PURE__ */ React.createElement(If, { condition: !outputLoading && (!outputs || !outputs.values || outputs.values.length == 0) }, /* @__PURE__ */ React.createElement(Empty, { hideIcon: true, message: "There are no outputs." })), /* @__PURE__ */ React.createElement(Loading, { visible: outputLoading, style: { width: "100%" } }, /* @__PURE__ */ React.createElement("div", { className: "step-info padding16" }, outputs?.values?.map((value) => {
          return /* @__PURE__ */ React.createElement("tbody", null, /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("th", null, "Name: "), /* @__PURE__ */ React.createElement("td", null, value.name)), /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("th", null, "Value: "), /* @__PURE__ */ React.createElement("td", null, value.value)), /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("th", null, "Value From"), /* @__PURE__ */ React.createElement("td", null, value.valueFrom || "-")));
        })))), /* @__PURE__ */ React.createElement(Tab.Item, { title: i18n.t("Inputs"), key: "inputs" }, /* @__PURE__ */ React.createElement(If, { condition: !inputLoading && (!inputs || !inputs?.values || inputs.values.length == 0) }, /* @__PURE__ */ React.createElement(Empty, { hideIcon: true, message: "There are no inputs." })), /* @__PURE__ */ React.createElement(Loading, { visible: inputLoading, style: { width: "100%" } }, /* @__PURE__ */ React.createElement("div", { className: "step-info padding16" }, /* @__PURE__ */ React.createElement("tbody", null, inputs?.values?.map((value) => {
          return /* @__PURE__ */ React.createElement("tbody", null, /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("th", null, "From Step: "), /* @__PURE__ */ React.createElement("td", null, value.fromStep)), /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("th", null, "From: "), /* @__PURE__ */ React.createElement("td", null, value.from)), /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("th", null, "Value: "), /* @__PURE__ */ React.createElement("td", null, value.value)), /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("th", null, "ParameterKey"), /* @__PURE__ */ React.createElement("td", null, value.parameterKey || "-")));
        }))))))
      ))
    ));
  }
};
ApplicationWorkflowRecord = __decorateClass([
  connect((store) => {
    return { ...store.application };
  })
], ApplicationWorkflowRecord);
export default ApplicationWorkflowRecord;
